import { render } from "./PageFilterBarTest.vue?vue&type=template&id=684afcd4&scoped=true"
import script from "./PageFilterBarTest.vue?vue&type=script&lang=js"
export * from "./PageFilterBarTest.vue?vue&type=script&lang=js"

import "./PageFilterBarTest.vue?vue&type=style&index=0&id=684afcd4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-684afcd4"

export default script